__turbopack_context__.v({
  "termsLink": "TokenTermsLink-module__NGghOW__termsLink",
  "termsLinkContainer": "TokenTermsLink-module__NGghOW__termsLinkContainer",
  "termsText": "TokenTermsLink-module__NGghOW__termsText",
});
